import { Autocomplete, CircularProgress, TextField } from '@mui/material'
import { useEffect, useState } from 'react'

import fetchWithAuth from '../../utilities/fetchWithAuth'

const RelationField = ({
  label,
  value,
  multiple,
  required,
  readOnly,
  onChange,
  error,
  helperText,
  path,
}) => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!path) return

    setLoading(true)
    fetchWithAuth(`${path}?page=0&pageSize=100&sort=name&order=asc`)
      .then(({ data }) => setOptions(data?.data ?? []))
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [path])

  return (
    <Autocomplete
      multiple={multiple}
      options={options}
      loading={loading}
      value={multiple ? (Array.isArray(value) ? value : []) : (value ?? null)}
      getOptionLabel={(o) => o?.name ?? o?.hardware_identifier ?? o?.uuid}
      isOptionEqualToValue={(o, v) => o?.uuid === v?.uuid}
      onChange={(_, newValue) => {
        onChange(newValue)
      }}
      disabled={readOnly}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size="small"
          required={required}
          error={error}
          helperText={helperText}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress size={16} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
    />
  )
}

export default RelationField
